import React from 'react';
import { Card, Flex, Divider } from '@applyboard/crystal-ui';
import { CardHeader } from "./CardHeader";
import { AmountSection } from "./AmountSection";
import { AutoAppliedSection } from "./AutoAppliedSection";
import { EligibleNationalitiesSection } from "./EligibleNationalitiesSection";
import { EligibleLevelsSection } from "./EligibleLevelsSections";
import { LearnMoreSection } from "./LearnMoreSection";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ScholarshipCard = function ScholarshipCard(_ref) {
  var scholarship = _ref.scholarship,
    eventTrackingOptions = _ref.eventTrackingOptions;
  return _jsxs(Card, {
    height: "fill",
    as: "article",
    "aria-label": "View scholarship ".concat(scholarship.title),
    emphasis: "elevated",
    children: [_jsxs(Flex, {
      direction: "column",
      gap: 4,
      height: "fill",
      children: [_jsxs(Flex, {
        direction: "column",
        children: [_jsx(CardHeader, {
          scholarshipTitle: scholarship.title,
          schoolGroupName: scholarship.schoolGroupName
        }), _jsx(Divider, {}), _jsx(AmountSection, {
          amountType: scholarship.awardAmountType,
          amountFrom: scholarship.awardAmountFrom,
          amountTo: scholarship.awardAmountTo,
          currencySymbol: scholarship.awardAmountCurrencySymbol,
          currencyCode: scholarship.awardAmountCurrencyCode
        })]
      }), _jsx(AutoAppliedSection, {
        autoApplied: scholarship.automaticallyApplied,
        eventTrackingOptions: eventTrackingOptions
      }), _jsx(EligibleNationalitiesSection, {
        eligibleNationalities: scholarship.eligibleNationalities
      }), _jsx(EligibleLevelsSection, {
        eligibleLevels: scholarship.eligibleLevels
      })]
    }), _jsx(Flex, {
      justify: "end",
      children: _jsx(LearnMoreSection, {
        path: scholarship.path,
        eventTrackingOptions: eventTrackingOptions
      })
    })]
  });
};